import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { CFRD_GALLERY } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/cfrd/gallery/")({
  component: () => <DeptContentList cfg={CFRD_GALLERY} />,
});
